import { Endpoint, Rest } from 'aurelia-api';
import { DialogService } from 'aurelia-dialog';
import { autoinject, inject, LogManager } from 'aurelia-framework';
import { Logger } from 'aurelia-logging';
import { HttpError } from '../../models/general';
import { Helpers } from '../../services/helpers';
import { AnswerViewModel } from './../../models/answerview-model';
import { AnswersModalCreate } from './answers-modal-create';
import { AnswersModalDelete } from './answers-modal-delete';
import { AnswersModalUpdate } from './answers-modal-update';

@autoinject
export class Answers {
	private logger: Logger = LogManager.getLogger('ANSWERS');
	private isRequesting: boolean = true;
	private serverError: HttpError | null = null;
	private model: Array<AnswerViewModel> | null = null;
	private search: string | null = null;
	private selectedField: string = 'order';
	private ascending: boolean = true;
	private showPagination: boolean = true;
	private paginationSelectedPage: number = 1;
	private paginationTake: number = 15;
	private paginationPages: number = 0;

	constructor(
		@inject(Endpoint.of('api'))
		private api: Rest,
		private dialogService: DialogService) { }

    async bind() {
        await this.getModel();
	}

    async getModel() {
        this.logger.debug('getModel');
        this.isRequesting = true;
        await this.api.find('/Answer/GetAll')
            .then((data: Array<AnswerViewModel>) => {
                this.model = data;
                Helpers.sortModel(this.model, this.selectedField, this.ascending);

                this.paginationPages = Math.ceil(this.model.length / this.paginationTake);
                this.showPagination = this.paginationPages > 1;
                this.logger.debug('Success: getModel');
			}).catch(async (err) => {
				var errorObj = await err.json();
				this.logger.debug('Error getModel: ', errorObj);

				// set errorMessage
				this.serverError = errorObj;
			});

        this.isRequesting = false;
	}

	sortModel(_class: Object[], field: string) {
		this.showPagination = false;
		this.selectedField = field;
		this.ascending === false ? this.ascending = true : this.ascending = false;
		this.paginationSelectedPage = 1;
		Helpers.sortModel(_class, this.selectedField, this.ascending);

		// make pagination control refresh because everyting in it is binding once
		setTimeout(() => {
			this.showPagination = this.paginationPages > 1;
		}, 100);
	}

	pageChanged($event, selectedPageNumber) {
		this.paginationSelectedPage = selectedPageNumber;
	}

	async newItem() {
		this.logger.debug('newItem');
		this.dialogService.open({ viewModel: AnswersModalCreate }).whenClosed(response => this.onClose(response));
	}

	async edit(id) {
		this.logger.debug('edit');
		this.dialogService.open({ viewModel: AnswersModalUpdate, model: { answerId: id }}).whenClosed(response => this.onClose(response));
	}

	async delete(id) {
		this.logger.debug('delete');
		this.dialogService.open({ viewModel: AnswersModalDelete, model: { answerId: id }}).whenClosed(response => this.onClose(response));
	}

	async onClose(response) {
		if (!response.wasCancelled) {
			await this.getModel();
			return response.output;
		} else {
			return null;
		}
	}
}